import theme from './theme.styl'

const typography = {
  size: {
    cardTitle: theme.cardSubtitleFontSize,
    body: theme.bodyText,
    main: theme.mainText,
    title: theme.titleText,
    subTitle: theme.subtitleText,
    paragraph: theme.paragraphText,
    caption: theme.captionText,
    error: theme.errorText,
  },
  weight: {
    semibold: theme.semibold,
    regular: theme.regular,
    bold: theme.bold,
  },
}

export const colors = {
  primary: theme.primary,
  negative: theme.negativeColor,
  negativeDark: theme.negativeColorDark,
  positive: theme.positiveColor,
  warning: theme.warningColor,
  warningLight: theme.warningColorLight,
  text: {
    primary: theme.ds_gray_1,
    subText: theme.ds_gray_2,
    secondary: theme.ds_gray_3,
    hint: theme.ds_gray_4,
    disabled: theme.ds_gray_5,
    link: theme.linksColor,
    highRisk: theme.highRisk,
    mediumRisk: theme.mediumRisk,
    lowRisk: theme.lowRisk,
    button: {
      primary: {
        default: theme.white,
        hover: theme.white,
        disabled: theme.ds_gray_5,
        loader: 'transparent',
        active: theme.white,
      },
      secondary: {
        default: theme.primary,
        hover: theme.ds_blue_2,
        disabled: theme.ds_gray_5,
        loader: 'transparent',
        active: theme.primary,
      },
      tertiary: {
        default: theme.primary,
        hover: theme.ds_blue_2,
        disabled: theme.ds_gray_5,
        loader: 'transparent',
        active: theme.primary,
      },
      fourth: {
        default: theme.primary,
        hover: theme.ds_blue_2,
        disabled: theme.ds_gray_5,
        loader: 'transparent',
        active: theme.primary,
      },
      upgrade: {
        default: theme.primary,
        hover: theme.primary,
        disabled: theme.primary,
        loader: 'transparent',
        active: theme.primary,
      },
      danger: {
        default: theme.negativeColor,
        hover: theme.danger_buttonHover,
        disabled: theme.ds_gray_5,
        loader: 'transparent',
        active: theme.negativeColor,
      },
    },
    reputation: {
      low: theme.highRisk,
      medium: theme.mediumRisk,
      high: theme.lowRisk,
    },
    risk: {
      low: theme.lowRisk,
      medium: theme.mediumRisk,
      normal: theme.mediumRisk,
      high: theme.highRisk,
    },
  },
  border: {
    button: {
      primary: {
        default: 'transparent',
        hover: 'transparent',
        disabled: 'transparent',
        loader: theme.primary,
        active: theme.primary,
      },
      secondary: {
        default: theme.primary,
        hover: theme.ds_buttonHover,
        disabled: theme.ds_gray_7,
        loader: theme.primary,
        active: theme.primary,
      },
      tertiary: {
        default: 'transparent',
        hover: 'transparent',
        disabled: 'transparent',
        loader: 'transparent',
        active: 'transparent',
      },
      fourth: {
        default: 'transparent',
        hover: theme.ds_buttonHover,
        disabled: 'transparent',
        loader: 'transparent',
        active: theme.primary,
      },
      upgrade: {
        default: 'transparent',
        hover: 'transparent',
        disabled: 'transparent',
        loader: 'transparent',
        active: theme.primary,
      },
      danger: {
        default: theme.negativeColor,
        hover: theme.danger_buttonHover,
        disabled: theme.ds_gray_7,
        loader: theme.negativeColor,
        active: theme.negativeColor,
      },
    },
  },
  background: {
    divider: theme.ds_gray_7,
    datePicker: {
      primary: theme.primary,
      selected: theme.ds_bg_paleBlue,
      hover: {
        chevron: theme.ds_bg_paleBlue,
      },
    },
    tag: {
      primary: theme.ds_gray_8,
    },
    banner: {
      primary: theme.ds_gray_7,
      warning: theme.ds_bg_lightPink,
    },
    button: {
      primary: {
        default: theme.primary,
        hover: theme.ds_blue_2,
        disabled: theme.ds_gray_8,
        loader: theme.primary,
        active: theme.ds_blue_2,
      },
      secondary: {
        default: theme.white,
        hover: theme.ds_blue_7,
        disabled: theme.white,
        loader: 'transparent',
        active: theme.ds_bg_paleBlue,
      },
      tertiary: {
        default: theme.white,
        hover: theme.ds_blue_7,
        disabled: theme.white,
        loader: theme.ds_bg_paleBlue,
        active: theme.ds_bg_paleBlue,
      },
      fourth: {
        default: theme.ds_bg_paleBlue,
        hover: theme.ds_blue_7,
        disabled: theme.ds_gray_7,
        loader: theme.ds_bg_paleBlue,
        active: theme.ds_bg_paleBlue,
      },
      upgrade: {
        default: '#CCEFFF',
        hover: '#ACE3FE',
        disabled: '#CCEFFF',
        loader: '#CCEFFF',
        active: '#ACE3FE',
      },
      danger: {
        default: theme.white,
        hover: theme.white,
        disabled: theme.white,
        loader: 'transparent',
        active: theme.ds_bg_paleBlue,
      },
    },
    dropdown: {
      selected: theme.ds_bg_paleBlue,
      hover: theme.ds_gray_8,
      preLabel: theme.ds_gray_8,
    },
    reputation: {
      low: '#FEEBEC',
      medium: '#FFE8D8',
      high: '#DEEEC4',
    },
    risk: {
      low: '#DEEEC4',
      medium: '#FFE8D8',
      normal: '#FFE8D8',
      high: '#FEEBEC',
    },
  },
  icons: {
    primary: theme.brandColor,
  },
  charts: {
    chart_1: theme.chart_1,
    chart_2: theme.chart_2,
    chart_3: theme.chart_3,
    chart_4: theme.chart_4,
    chart_5: theme.chart_5,
    chart_6: theme.chart_6,
    chart_7: theme.chart_7,
    chart_8: theme.chart_8,
    chart_9: theme.chart_9,
    chart_10: theme.chart_10,
    chart_11: theme.chart_11,
    chart_12: theme.chart_12,
    chart_13: theme.chart_13,
    chart_14: theme.chart_14,
    chart_15: theme.chart_15,
    chart_16: theme.chart_16,
  },
  chartsHover: {
    chart_1: theme.chart_hover_1,
    chart_2: theme.chart_hover_2,
    chart_3: theme.chart_hover_3,
    chart_4: theme.chart_hover_4,
    chart_5: theme.chart_hover_5,
    chart_6: theme.chart_hover_6,
    chart_7: theme.chart_hover_7,
    chart_8: theme.chart_hover_8,
    chart_9: theme.chart_hover_9,
    chart_10: theme.chart_hover_10,
    chart_11: theme.chart_hover_11,
    chart_12: theme.chart_hover_12,
    chart_13: theme.chart_hover_13,
    chart_14: theme.chart_hover_14,
    chart_15: theme.chart_hover_15,
    chart_16: theme.chart_hover_16,
  },
}

/*
  shadows
  colors
  layout
*/

/**
 * @typedef {Object} Theme
 * @property {string} zIndexModal
 * @property {string} zIndexModalX
 * @property {string} zScrollToTopButton
 * @property {string} zIndexRCTopBar
 * @property {string} baseMargin
 * @property {string} cardPadding
 * @property {string} navigationHeight
 * @property {string} resolutionListWidth
 * @property {string} collapsedResolutionListWidth
 * @property {string} primaryColor
 * @property {string} contrastColor
 * @property {string} contrastLightColor
 * @property {string} warningColor
 * @property {string} warningColorLight
 * @property {string} secondaryColor
 * @property {string} textGray
 * @property {string} borders
 * @property {string} linksColor
 * @property {string} red
 * @property {string} gray
 * @property {string} grayLight
 * @property {string} green
 * @property {string} blackish
 * @property {string} priorityLow
 * @property {string} priorityMedium
 * @property {string} priorityHigh
 * @property {string} modalBackgroundColor
 * @property {string} zIndexDropdown
 * @property {string} zIndexStickyHeaders
 * @property {string} zIndexTableRow
 * @property {string} rcTabletPoint
 * @property {string} rcTabletPointMin
 * @property {string} rcPhonePointMin
 * @property {string} rcPhonePoint
 * @property {string} rcCollapseListPoint
 * @property {string} rcCollapseReportAction
 * @property {string} incidentLabelBackgroundColor
 * @property {string} incidentLabelBackgroundColorAC
 * @property {string} incidentLabelColor
 * @property {string} incidentLabelColorAC
 * @property {string} borderRadius
 * @property {string} roundButtonRadius
 * @property {string} squareButtonRadius
 * @property {string} cardBorderColor
 * @property {string} cardSubtitleFontSize
 * @property {string} negativeColor
 * @property {string} negativeColorDark
 * @property {string} positiveColor
 * @property {string} bold
 * @property {string} semibold
 * @property {string} regular
 * @property {string} ds_buttonHover
 * @property {string} ds_gray_1
 * @property {string} ds_gray_2
 * @property {string} ds_gray_3
 * @property {string} ds_gray_4
 * @property {string} ds_gray_5
 * @property {string} ds_gray_6
 * @property {string} ds_gray_7
 * @property {string} ds_gray_8
 * @property {string} ds_gray_9
 * @property {string} white
 * @property {string} ds_bg_1
 * @property {string} ds_bg_navyBlue
 * @property {string} ds_bg_periwinkle
 * @property {string} ds_bg_paleBlue
 * @property {string} ds_bg_lightPink
 * @property {string} chart_1
 * @property {string} chart_2
 * @property {string} chart_3
 * @property {string} chart_4
 * @property {string} chart_5
 * @property {string} chart_6
 * @property {string} chart_7
 * @property {string} chart_8
 * @property {string} chart_9
 * @property {string} chart_10
 * @property {string} chart_11
 * @property {string} chart_12
 * @property {string} chart_13
 * @property {string} chart_14
 * @property {string} chart_15
 * @property {string} chart_16
 * @property {string} chart_hover_1
 * @property {string} chart_hover_2
 * @property {string} chart_hover_3
 * @property {string} chart_hover_4
 * @property {string} chart_hover_5
 * @property {string} chart_hover_6
 * @property {string} chart_hover_7
 * @property {string} chart_hover_8
 * @property {string} chart_hover_9
 * @property {string} chart_hover_10
 * @property {string} chart_hover_11
 * @property {string} chart_hover_12
 * @property {string} chart_hover_13
 * @property {string} chart_hover_14
 * @property {string} chart_hover_15
 * @property {string} chart_hover_16
 * @property {string} primary
 * @property {string} buttonHover
 * @property {string} highRisk
 * @property {string} mediumRisk
 * @property {string} lowRisk
 * @property {string} bodyText
 * @property {string} mainText
 * @property {string} titleText
 * @property {string} subtitleText
 * @property {string} paragraphText
 * @property {string} captionText
 * @property {string} labelText
 * @property {string} errorText
 * @property {string} brandColor
 */

/**
 * @typedef {Object} StyledTheme
 * @property {Theme} theme
 * @property {typeof colors} colors
 * @property {typeof typography} typography
 */

/** @type {StyledTheme} */
const styledTheme = {
  ...theme,
  colors,
  typography,
}

globalThis.theme = styledTheme
export default styledTheme
